import React from "react";
import { Link } from "react-router-dom";

export default function LegalLayout({ title, kicker, lastUpdated, children }) {
  return (
    <div
      data-testid="legal-page"
      className="min-h-screen bg-[#050505] text-[#f5f5f5] pt-32 pb-24"
    >
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <Link to="/" className="overline" data-testid="legal-back-link">
          ← Back to portfolio
        </Link>
        <div className="mt-10 mb-12">
          <p className="overline mb-4">
            <span className="accent-bar" />
            {kicker}
          </p>
          <h1
            className="font-display font-light leading-[0.95] tracking-[-0.03em]"
            style={{ fontSize: "clamp(2.6rem, 6vw, 5rem)" }}
          >
            {title}
          </h1>
          <p className="overline mt-6">Last updated · {lastUpdated}</p>
        </div>
        <div className="dotted-line mb-10" />

        <div
          className="prose-legal text-[#d4d4d4] leading-relaxed text-base md:text-lg space-y-6"
          data-testid="legal-content"
        >
          {children}
        </div>

        <div className="mt-20 pt-10 border-t border-white/10 flex items-center justify-between flex-wrap gap-4">
          <span className="overline">
            COPYRIGHT RANJANA SUMAN BARUAH
          </span>
          <Link to="/" className="nav-link" data-testid="legal-home-link">
            Return home →
          </Link>
        </div>
      </div>
    </div>
  );
}
